import styled from "styled-components";

export const TableGridStyled = styled.div`
  display: grid;
  grid-template-columns: minmax(400px, 500px) repeat(5, minmax(150px, 1fr)) 70px;
  row-gap: 32px;
  overflow-x: auto;
  background-color: ${({ theme }) => theme.old.colors.white};
  padding-bottom: 24px;
  margin-bottom: 40px;
`

export const ErrorContainer = styled.div`
  display: grid;
  place-items: center;

  background-color: ${({ theme, $isCreators }) => theme.old.colors.white};
  border-top: 2px solid ${({ theme }) => theme.old.colors.gray[800]};
  border-radius: '0 0 12px 12px';
  height: 400px;
`
